import mixpanel from 'mixpanel-browser';
import { getMixpanelToken } from '#config';

export const buildMixpanelTracker = () => {
  const enabled = !!getMixpanelToken();

  const setUser = ({ id, ...other }) => {
    if (!enabled || !mixpanel?.identify) return; // Wait to be instantiated
    if (!id) throw new Error('User ID is required');
    mixpanel.identify(id);
    mixpanel.people.set(other);
  };

  const track = (event, params = {}) => {
    if (!enabled || !mixpanel?.track) return; // Wait to be instantiated
    mixpanel?.track(event, params);
  };

  return {
    setUser,
    track,
  };
};
